import React from "react";
import styles from "./About.module.css";

/* Local Images */
import storyImg from "../assets/about/story.png";
import purposeImg from "../assets/about/purpose.png";

export default function About() {
  return (
    <main className={styles.page}>

      {/* OUR STORY */}
      <section className={styles.section}>
        <span className={styles.glowPeach} />

        <div className={styles.grid}>
          <div className={styles.text}>
            <h1 className={styles.title}>Our Story</h1>

            <p className={styles.lead}>
              Built with care, warmth, and a deep belief in childhood.
            </p>

            <p>
              Our Founders <strong>Jahnavi Reddy</strong> &{" "}
              <strong>Rupika Rajendran</strong> created{" "}
              <strong>Happy Horizon</strong> with a simple yet grounded vision —
              to build a space where <strong>children can be themselves</strong>,
              play freely, learn creatively, and feel truly happy.
            </p>

            <p>
              In today’s fast-paced world, <strong>children need safe spaces</strong>
              to move, imagine, and connect. Parents need{" "}
              <strong>trusted environments</strong> where their children can grow
              with confidence.
            </p>

            <p className={styles.highlight}>
              Happy Horizon brings these together under one roof.
            </p>
          </div>

          <div className={styles.imageWrap}>
            <img src={storyImg} alt="Happy Horizon story" />
          </div>
        </div>
      </section>

      {/* OUR PURPOSE */}
      <section className={`${styles.section} ${styles.soft}`}>
        <span className={styles.glowMint} />

        <div className={`${styles.grid} ${styles.reverse}`}>
          <div className={styles.imageWrap}>
            <img src={purposeImg} alt="Happy Horizon purpose" />
          </div>

          <div className={styles.text}>
            <h1 className={styles.title}>Our Purpose</h1>

            <p>
              At the heart of <strong>Happy Horizon</strong> is a commitment to{" "}
              <strong>child-centered experiences</strong>. We support children
              during their most important developmental years by nurturing:
            </p>

            <ul className={styles.list}>
              <li>Physical movement</li>
              <li>Creativity</li>
              <li>Emotional well-being</li>
              <li>Social connection</li>
            </ul>

            <p>
              We also believe in supporting families by creating a space where{" "}
              <strong>parents feel confident, relaxed, and reassured</strong>
              while their children play, learn, and grow.
            </p>

            <p className={styles.highlight}>
              Happy Horizon is not just a play area — it’s a community space.
            </p>
          </div>
        </div>
      </section>

    </main>
  );
}
